import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import ChatWidget from "./components/ChatWidget";
import LandingPage from "./pages/LandingPage";
import Dashboard from "./pages/Dashboard";
import Backtest from "./pages/Backtest";
import Statistics from "./pages/Statistics";
import Settings from "./pages/Settings";
import Subscription from "./pages/Subscription";
import OnboardingBrokerConnect from "./pages/OnboardingBrokerConnect";
import Admin from "./pages/Admin";
import ChartChromePreview from './pages/ChartChromePreview';
import Login from "./pages/Login";
import VerifyEmail from "./pages/VerifyEmail";
import ResetPassword from "./pages/ResetPassword";
import { Toaster } from "./components/ui/sonner";
import { buildApiUrl } from "./services/apiBase";

export const API = buildApiUrl('/api');

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
      <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<Login />} />
            {process.env.REACT_APP_ENABLE_UI_PREVIEW === "1" ? (
              <Route path="/__chart-preview" element={<ChartChromePreview />} />
            ) : null}
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            
            {/* Protected Routes */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/backtest" element={
              <ProtectedRoute>
                <Backtest />
              </ProtectedRoute>
            } />
            <Route path="/statistics" element={
              <ProtectedRoute>
                <Statistics />
              </ProtectedRoute>
            } />
            <Route path="/settings" element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            } />
            <Route path="/subscription" element={
              <ProtectedRoute>
                <Subscription />
              </ProtectedRoute>
            } />
            <Route path="/onboarding/broker-connect" element={
              <ProtectedRoute>
                <OnboardingBrokerConnect />
              </ProtectedRoute>
            } />
            <Route path="/admin" element={
              <ProtectedRoute>
                <Admin />
              </ProtectedRoute>
            } />
          </Routes>
          {/* Global Chat Widget - shows on all protected pages */}
          <ChatWidget />
        </BrowserRouter>
        <Toaster 
          position="bottom-right" 
          toastOptions={{
            style: {
              background: '#0a0a0a',
              border: '1px solid #262626',
              color: '#f5f5f5',
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '12px'
            }
          }}
        />
      </AuthProvider>
      </ThemeProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
